import en from './en'
import fr from './fr'
import de from './de'

export const uppyLang = {en, fr, de}
